import React, { useContext, useEffect, useState } from "react";
import "./SelectRamlComp.css";
import { ramlKey } from "../../data";
import { SelectRamlContext } from "../../contexts/SelectRamContext";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { Link, useNavigate } from "react-router-dom";
import { Button, Row, Col, Container } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { useForm, Controller } from "react-hook-form";
import ApiGetX2 from "../../utils/ApiServicesX/ApiGetX2";
import { MainContext } from "../../contexts/MainContext";
import ModalFull from "../../utils/Modals/ModalFull";
import DateFormat from "../../utils/DateFormat";
import ApiDeleteX2 from "../../utils/ApiServicesX/ApiDeleteX2";
import MyZayecheh from "../../utils/Modals/MyZayecheh";
export default function SelectRamlComp() {
  let {
    setLotNameCon,
    setTitleIdCon,
    setQuestionIdCon,
    userId,
    titleTopics,
    setAllShaps,
    setAllSource,
  } = useContext(MainContext);
  const navigate = useNavigate();

  const [ramlData, setRamlData] = useState(ramlKey);
  const ramlContext = useContext(SelectRamlContext);
  const [allUserShaps, setAllUserShaps] = useState([false]);
  const [question, setQuestion] = useState([]);
  const [titleId, setTitleId] = useState("");
  const [questionId, setQuestionId] = useState("");
  const sortedTitle = titleTopics?.sort((a, b) => a.order - b.order);
  const sortedQuestion = question?.sort((a, b) => a.order - b.order);
  const [state, setState] = useState(false);

  const {
    control,
    register,
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: "",
    },
  });
  const selectedTitle = watch("title");
  const selectedQuestion = watch("question");
  ///////////////////////
  const resethandler = () => {
    ramlContext.setResObj([]);
  };
  ///////////////////////
  function imgClick(e, w) {
    let x = ramlData.filter((item) => item.src === w);
    // let obj={x}
    if (ramlContext.resobj.length < 4) {
      ramlContext.setResObj((prev) => [...prev, x]);
    }
  }

  const handleRegistration = (data) => {
    setAllShaps([])
    setLotNameCon(data.name);
    setTitleIdCon(data.title);
    setQuestionIdCon(data.question);

    navigate("/ramlpic");
  };

  const deletUserShape = (id) => {
    const url = `/api/AgMain/deleteUseShape?UShapId=${id}`;
    const url2 = `/api/AgMain/getUserShapeByUserID?userId=${userId}`;
    ApiDeleteX2(url, function () {
      ApiGetX2(url2, setAllUserShaps); ////<== گرفتن مجدد شکلهای کاربر بعد از انجام عمل حذف
    });
  };

  useEffect(() => {
    setTitleId(selectedTitle);
  }, [selectedTitle]);

  useEffect(() => {
    setQuestionId("");
    if (titleId) {
      const url = `/api/AgTopics/getQuestionByTopicID?tId=${titleId}`;
      ApiGetX2(url, setQuestion);
    } else {
      setQuestion([]);
    }
  }, [titleId]);


  useEffect(() => {
    const url3 = `/api/AgSource/getAllSources`;
    ApiGetX2(url3, setAllSource);
  }, []);
  return (
    <>
      <Container className="container selecramlcom2-container ">
        <Row>
          <Col md={7}>
            <>
              <div
                className={
                  ramlContext.resobj.length < 4
                    ? "row row-cols-4 mt-5 selecramlcom2-div displayon"
                    : "row row-cols-4 mt-5 selecramlcom2-div disable"
                }
              >
                {ramlData.map((item) => (
                  <div
                    className="selecramlcom2-div-img"
                    onClick={(e) => {
                      imgClick(e, `${item.src}`);
                    }}
                  >
                    {" "}
                    <img class="kolImg" src={item.src} alt="" />
                  </div>
                ))}
              </div>

              <span
                className={
                  ramlContext.resobj.length < 4
                    ? "selecramlcom2-div-span"
                    : "selecramlcom2-div-span hide"
                }
              >
                شکل :{ramlContext.resobj.length + 1}
              </span>
              <div
                className="selecramlcom2-resetimg centerrc"
                onClick={resethandler}
              >
                <RestartAltIcon />
              </div>
            </>
          </Col>
          <Col md={1}></Col>

          <Col md={3} className="selectraml-inputs centerc">
            <>
              <Form
                onSubmit={handleSubmit(handleRegistration)}
                className="centercc"
              >
                <Form.Group className="mb-3" controlId="formname">
                  <Form.Control
                    type="text"
                    placeholder="نام (اختیاری) ..."
                    {...register(
                      "name"
                      //   , {
                      //   required: " وارد کردن نام الزامی است ...",
                      // }
                    )}
                  // isInvalid={!!errors.name}
                  />
                  <Form.Control.Feedback type="invalid">
                    {/* {errors.phone?.message} */}
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Select
                  aria-label="Default select example"
                  {...register("title", {
                    onChange: (e) => {
                      setTitleId(e.target.value);
                      reset({
                        question: "",
                      });
                    },
                  })}
                >
                  <option value="">انتخاب موضوع (اختیاری)...</option>
                  {titleTopics.length !== 0 &&
                    sortedTitle?.map((item) => (
                      <option value={item.id} key={item.id}>
                        {item.description}
                      </option>
                    ))}
                </Form.Select>

                <Form.Select
                  aria-label="Default select example"
                  {...register("question", {
                    onChange: (e) => {
                      setQuestionId(e.target.value);
                    },
                  })}
                >
                  <option value="">انتخاب سوال (اختیاری)...</option>
                  {question.length !== 0 &&
                    sortedQuestion?.map((item) => (
                      <option value={item.id} key={item.id}>
                        {item.description}
                      </option>
                    ))}
                </Form.Select>

                <Form.Select
                  aria-label="Default select example"
                  {...register("circle")}
                >
                  <option>انتخاب دایره (اختیاری)...</option>
                  <option value="1">One</option>
                  <option value="2">Two</option>
                  <option value="3">Three</option>
                </Form.Select>

                <Link className={"linkBtn"} to="/selectraml">
                  {" "}
                  ادعیه{" "}
                </Link>
                {/* 
                <button
                  className={
                    ramlContext.resobj.length < 4
                      ? "linkBtn click_disable"
                      : "linkBtn"
                  }
                  type="submit"
                  // to="/ramlpic"
                >
                  {" "}
                  تایید
                </button> */}

                <button
                  className={
                    ramlContext.resobj.length < 4
                      ? "linkBtn click_disable"
                      : "linkBtn"
                  }
                  type="submit"
                // to="/ramlpic"
                >
                  {" "}
                  تایید و ذخیره
                </button>

                <button
                  onClick={() => {
                    setState(true);
                    setInterval(() => {
                      setState(false);
                    }, 0.5);
                  }}
                  className="linkBtn"
                  type="button"
                // to="/ramlpic"
                >
                  {" "}
                  زاییچه های من
                </button>

                <MyZayecheh state={state} />
              </Form>
            </>
          </Col>
        </Row>
      </Container>
    </>
  );
}
